import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth';
import styles from 'styles/modules/SidebarNav.module.scss';
import { useRouter } from 'next/router';
import NavigationLinks from './Nav/NavigationLinks';

const SidebarNav = () => {
    const router = useRouter();

    const auth = useSelector(authSelector);
    if (!router.query.company && !auth.company) {
        return null;
    }

    return (
        <nav className={styles.wrapper}>
            <NavigationLinks styles={styles} />
        </nav>
    );
};

export default SidebarNav;
